import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { PageAction, PermissionEntry, PermissionType } from '@tencent/docs-service-interface';
import { DocsComponentName } from "../../constant";
import { getExtensionSafe } from "../../utils";
import { openInNewWindow } from "./browser-util";

/**
   * 打开权限面板
   * @param options
   */
export var openPermissionSetting = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
    var newWindow, extension;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          newWindow = options.newWindow;
          if (!newWindow) {
            _context.next = 4;
            break;
          }
          openInNewWindow(PageAction.OPEN_PERMISSION_SETTING, options);
          return _context.abrupt("return");
        case 4:
          _context.next = 6;
          return getExtensionSafe(DocsComponentName.PRIVATIZED_PERMISSION);
        case 6:
          extension = _context.sent;
          extension.show(options);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function openPermissionSetting(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
   * 打开成员面板
   */
export var openMemberPanel = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
    var newWindow, memberButtonOptions, extension;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          newWindow = options.newWindow;
          memberButtonOptions = _objectSpread({
            type: PermissionType.FILE,
            entry: PermissionEntry.MEMBER_MANAGEMENT
          }, options);
          if (!newWindow) {
            _context2.next = 5;
            break;
          }
          openInNewWindow(PageAction.OPEN_PERMISSION_SETTING, memberButtonOptions);
          return _context2.abrupt("return");
        case 5:
          _context2.next = 7;
          return getExtensionSafe(DocsComponentName.PRIVATIZED_PERMISSION);
        case 7:
          extension = _context2.sent;
          extension.show(memberButtonOptions);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function openMemberPanel(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
   * 打开创建共享空间面板
   * @param options
   */
export var openCreateSpaceSetting = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
    var extension;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getExtensionSafe(DocsComponentName.PRIVATIZED_PERMISSION);
        case 2:
          extension = _context3.sent;
          extension.show(_objectSpread({
            type: PermissionType.SPACE,
            entry: PermissionEntry.CREATE_SPACE
          }, options));
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function openCreateSpaceSetting(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/**
   * 打开共享空间设置面板
   * @param options
   */
export var openSpaceSetting = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options) {
    var extension;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return getExtensionSafe(DocsComponentName.PRIVATIZED_PERMISSION);
        case 2:
          extension = _context4.sent;
          extension.show(_objectSpread({
            type: PermissionType.SPACE,
            entry: PermissionEntry.SPACE_MANAGEMENT
          }, options));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function openSpaceSetting(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * 打开表单填写链接管理面板
 * @param options
 */
export var openFormFillPanel = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
    var extension;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return getExtensionSafe(DocsComponentName.FORM_FILL_MANAGEMENT);
        case 2:
          extension = _context5.sent;
          extension.show(options);
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function openFormFillPanel(_x5) {
    return _ref5.apply(this, arguments);
  };
}();